import { Route, Routes, Navigate } from 'react-router';

import HomePage from 'src/pages/home-page';
import AboutPage from 'src/pages/about-page';
import { MainLayout } from 'src/layouts/main-layout';
import ContactPage from 'src/pages/contact-page';
import PrivacyPage from 'src/pages/privacy-page';
import ServicePage from 'src/pages/service-page';
import NotFoundPage from 'src/pages/not-found-page';
import { servicePages } from 'src/sections/service/service-pages';

import { paths, legacyRedirects } from './paths';

export function Router() {
  return (
    <Routes>
      <Route element={<MainLayout />}>
        <Route index element={<HomePage />} />
        <Route path={paths.about} element={<AboutPage />} />
        <Route path={paths.contact} element={<ContactPage />} />
        <Route path={paths.privacy} element={<PrivacyPage />} />

        {servicePages.map((config) => (
          <Route key={config.path} path={config.path} element={<ServicePage {...config} />} />
        ))}

        {legacyRedirects.map((redirect) => (
          <Route
            key={redirect.from}
            path={redirect.from}
            element={<Navigate replace to={redirect.to} />}
          />
        ))}

        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}
